import React, { useEffect, useRef, useState } from "react";
import { SelectBox } from "components/Select/Select";
import { getDictionarySelectBox } from "./api";
import { InputLoad } from "components/InputLoading/inputLoading";
import { GUID_EMPTY } from "utils/constants";

interface DictionaryTypeSelectProps {
  value?: any;
  mode?: string;
  resetForm?: boolean;
  revert?: boolean;
  name: string;
  label: string;
  endPoint: string;
  baseUrl?: string;
  required?: boolean;
  keyForDictionary?: string;
  transe?: boolean;
  goToFristWithReset?: boolean;
  params?: any;
  recordedData?: any;
  Change?: (e) => void;
  onChange?: (e: any, obj?: any) => void;
  useTrans?: boolean;
  addCustomValue?:any;
  valueString?:any
}
export const DictionarySelectBox = React.memo(({
  recordedData,
  revert = false,
  params,
  label,
  required = false,
  keyForDictionary,
  baseUrl,
  useTrans = false,
  goToFristWithReset=false,
  endPoint,
  value,
  name,
  mode,
  resetForm,
  onChange,
  Change,
  valueString,
  addCustomValue=false
}: DictionaryTypeSelectProps) => {
  const [dictionarySelectBox, setDictionarySelectBox] = useState<any>();
  const [errcode, setErrcode] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
const flag=useRef<any>(false)  

  const getDictionarySelectBoxAsync = async () => {
    setLoading(false);
    try {  const res = await getDictionarySelectBox(endPoint, baseUrl, params);
    if (res?.Data == null || res?.Data?.Data || typeof Object.values(res.Data)?.[0]=="object") {
      setDictionarySelectBox({});
      } else {
        if (res?.Data) {
          if(addCustomValue){
            setDictionarySelectBox({[addCustomValue]:null,...res?.Data});
            
          }else{
            
            setDictionarySelectBox(res?.Data);
          }
          if (!value) {
            if(!keyForDictionary){
              onChange &&
              onChange(Object.keys(res?.Data)[0], {
                Id: Object.keys(res?.Data)[0],
                Name: Object.values(res?.Data)[0],
              });
            }else{
              onChange &&
              onChange(Object.keys(res?.Data)[0],Object.values(res?.Data)[0]);
            }
          } else {
              if(!keyForDictionary){
              onChange &&
              onChange(value, {
                Id: value,
                // Name: Object.values(res?.Data)[value],
                Name: res?.Data[value],

              });
            }else{
              onChange &&
              onChange(value,res?.Data[value]);
            }
            }
          
        } else {
          setDictionarySelectBox(res);
          if(!keyForDictionary){
            onChange &&
            onChange(Object.keys(res)[0], {
              Id: Object.keys(res)[0],
              Name: Object.values(res)[0],
            });
          }else{
            onChange &&
            onChange(Object.keys(res)[0], Object.values(res)[0]);

          }
        }
      }
    
    } catch (error: any) {
      setErrcode(error.response?.status);
      setDictionarySelectBox(null);
    }
    setLoading(true);
  };

  const handleOnChange = (e) => {
    if(!keyForDictionary){
      onChange &&
        onChange(e.target.value, {
          Id: e.target.value,
          Name: dictionarySelectBox[e.target.value],
        });
    }else{
      onChange &&
        onChange(e.target.value, dictionarySelectBox[e.target.value]);
    }
    Change && Change(true);

    if (
      e.target &&
      e.target.value != (value ? value : Object.keys(dictionarySelectBox)[0])
    ) {
      Change && Change({ [name]: e.target.value });
    } else {
      Change && Change({ [name]: null });
    }
  };


    useEffect(() => {
     if( params && !!Object.keys(params).length && flag.current){
    getDictionarySelectBoxAsync();}
  }, [params && JSON.stringify(params)]);

  useEffect(() => {
    if(mode=='view' && valueString){
onChange &&  onChange(value,valueString);
setDictionarySelectBox({value:valueString})
setLoading(true)
    }else{
      getDictionarySelectBoxAsync();
      flag.current=true
    }
 }, []);





  return (
    <>
      {dictionarySelectBox && loading ? (
        <>
          <SelectBox
            onChange={(e) => {
              handleOnChange(e);
            }}
            lable={label}
            selectType={"select"}
            options={
              revert
                ? Object.keys(dictionarySelectBox)
                :( keyForDictionary? Object.values(dictionarySelectBox).map((item:any)=>item[keyForDictionary+""]) : Object.values(dictionarySelectBox))
            }
            val={Object.keys(dictionarySelectBox)}
            name={name}
            value={value}
            goToFristWithReset={goToFristWithReset}
            resetForm={resetForm}
            mode={mode}
            required={required}
            useTrans={useTrans}
            recordedData={recordedData}
          />
          <div className="text-box__msg-wrapper"></div>
        </>
      ) : (
        <InputLoad
          msg={errcode}
          required={required}
          labelText={label}
          onClick={getDictionarySelectBoxAsync}
        />
      )}
    </>
  );
});
